import styled from 'styled-components';
import Navigation from '../components/header/Navigation';
import withAuthorization from '../session/with_authorization';
import { isSubscriptionTypeBasic } from '../utils/CheckSubscriptionType';

const OpenstaxTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 30vh;
  padding: 4px;
  gap: 10px;
`;

const OpenstaxText = styled.p`
  color: var(--color-light-gray);
  font-size: 16px;
`;

function OpenstaxPage() {
  return (
    <>
      <Navigation />
      <OpenstaxTitleWrapper>
        <h1>Welcome to Inflo</h1>
        <OpenstaxText>
          Our web platform is limited to our PRO users - Enjoy the OpenStax
          educational content in iOS or upgrade to Inflo Pro + Openstax and gain
          full access
        </OpenstaxText>
      </OpenstaxTitleWrapper>
    </>
  );
}

const authCondition = (authUser: any) => {
    !!authUser && isSubscriptionTypeBasic(authUser.subscriptionType);
}
export default withAuthorization(authCondition)(OpenstaxPage);
